/* eslint-disable @nx/enforce-module-boundaries */
import { HStack, Stack, Text } from '@mybridge/ui';
import { MyDiskUsagePanel } from 'v4/components/disk/my-disk/disk-usage';
import { DiskDownloadProgress } from 'v4/components/disk/download-progress';
import { DiskFileInfoSection } from 'v4/components/disk/file-info-section';
import { useContext } from 'react';
import { DiskContext } from 'v4/components/disk/context';
import { isMobile } from 'react-device-detect';
import { Box } from '@chakra-ui/react';

export const BottomPanel = () => {
  const { selectedMainDirType, selectedSharedDiskUser, } =
    useContext(DiskContext);
    
  return (
    <HStack bg={'white'} borderTop="1px solid " borderColor="gray.100" width="100%">
      {isMobile ? (
        <Box py={3} pb={5} w='full'>
          <MyDiskUsagePanel />
        </Box>
      ) : (
        <>
          <Stack p={4} w="30%" borderRight="1px solid" borderColor="gray.100">
            <MyDiskUsagePanel />
          </Stack>
          <Stack p={4} flex={1} w="100%">
            {selectedMainDirType === 'shared-disk' &&
            !selectedSharedDiskUser ? (
              ''
            ) : (
              <DiskFileInfoSection />
            )}
          </Stack>
          {/* <Stack p={4} w="15%" alignItems="center">
            <DiskDownloadProgress />
          </Stack> */}
        </>
      )}
    </HStack>
  );
};
